import { createFileRoute } from "@tanstack/react-router"

import { ExpertPanel } from "@/pages/ExpertPanel"

export const Route = createFileRoute("/intelligence/expert")({
  component: ExpertPanel,
})
